import React from "react";
import { Modal, Input } from "antd";

const CustomModal = ({ children, ...props }: any) => {
  return <Modal {...props}>{children}</Modal>;
};

export default CustomModal;
